export const REFERRAL_CODE_FOR_REG_KEY = 'user::referral-code-for-registration'

export function getReferralCodeFromLocalStorage(): string | null {
  return localStorage.getItem(REFERRAL_CODE_FOR_REG_KEY)
}
export function setReferralCodeToLocalStorage(code: string) {
  return localStorage.setItem(REFERRAL_CODE_FOR_REG_KEY, code)
}

export function deleteReferralCodeFromLocalStorage() {
  return localStorage.removeItem(REFERRAL_CODE_FOR_REG_KEY)
}
